import React from "react";

import fastexLogo from "../../assets/icons/fastex.svg";

import style from "../signin.module.css";

const LoginWithFastex = () => {
    const currentLocation = window.location.origin;
    const fastexAuthUrl = process.env.REACT_APP_FASTEX_AUTH_URL;
    const responseType = "code";
    const scope = "account+balances";
    const clientId = '6';
    const state = 'ffffffffffffffffffffffffffffffffffffffffffffffffffffffffdsdvv';

    const fastexAuth = () => {
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

        const systemZoom = width / window.screen.availWidth;
        const left = width / 3 / systemZoom + dualScreenLeft
        const top = height / 3 / systemZoom + dualScreenTop
        const windowFeatures = `popup,top=${top},left=${left},width=${0.25 * width},height=${0.5 * height}`;
        window.open(`${fastexAuthUrl}authorize?client_id=${clientId}&redirect_uri=${currentLocation}/fastex&response_type=${responseType}&scope=${scope}&state=${state}`, "_blank", windowFeatures);
    }

    return (
        <a className={style.social_btn} onClick={fastexAuth}>
            <img className={style.social_img} src={fastexLogo} alt="fastex"/>
        </a>
    )
}

export default LoginWithFastex;